import { applyRail } from '../../../design/sidebar.js';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import '../../../design/tokens.css';
import '../../../design/console.css';
import './styles/product.css';
import { router } from './app/router';
import { retryRead } from './api/client';
import { RequireAuth } from './app/auth';
const client = new QueryClient({ defaultOptions: { queries: { retry: retryRead, retryDelay: attempt => Math.min(1000 * 2 ** attempt, 4000), staleTime: 60_000, refetchOnWindowFocus: false, refetchOnReconnect: true } } });
async function start() {
  applyRail();
  if (import.meta.env.MODE === 'mock') {
    const { worker } = await import('./mocks/browser');
    await worker.start({ quiet: true, onUnhandledRequest(request, print) {
      if (new URL(request.url).pathname.startsWith('/api/')) print.error();
    } });
  }
  const script = document.createElement('script'); script.src = '/_console/switcher.js'; document.head.append(script);
  ReactDOM.createRoot(document.getElementById('root')!).render(<QueryClientProvider client={client}><RequireAuth><RouterProvider router={router}/></RequireAuth></QueryClientProvider>);
}
void start();
